import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom'

const Menu = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='menus'>
                <div className='container'>
                    {/* <div className='file-icon'>
                        <FaReceipt />
                        <span className='noti'>53</span>
                    </div> */}

                    <nav className="nav nav-menu d-flex flex-nowrap">
                        <NavLink className="nav-link text-uppercase" to="/">{t("Home")}</NavLink>
                        <NavLink className="nav-link text-uppercase" to="/calendar">{t("Calendar")}</NavLink>
                        {/* <NavLink className="nav-link text-uppercase" to="/voting">{t("Vote")}!</NavLink> */}
                        {/* <NavLink className="nav-link text-uppercase" to="/event-history">{t("History")}</NavLink> */}
                        <NavLink className="nav-link text-uppercase" to="/my-profile">{t("Profile")}</NavLink>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default Menu
